import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'squareMeters'})
export class SquareMetersPipe implements PipeTransform {
  transform(value: number): number {
    if (value < 1) {
      return Math.round(value * 10000);
    } else {
      return Math.round(value);
    }
  }
}
